import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const MetadataPanel = ({ drawing }) => {
  const { t } = useLanguage();

  if (!drawing) return null;

  const fields = [
    { label: t('drawingNumber'), value: drawing?.drawing_number, icon: 'Hash' },
    { label: t('drawingName'), value: drawing?.drawing_name, icon: 'FileText' },
    { label: t('discipline'), value: drawing?.discipline, icon: 'Layers' },
    { label: t('revision'), value: drawing?.revision, icon: 'GitBranch' },
    { label: t('site'), value: drawing?.sites?.site_name, icon: 'MapPin' },
    { label: t('uploaded'), value: drawing?.upload_date ? new Date(drawing.upload_date)?.toLocaleDateString() : drawing?.created_at ? new Date(drawing.created_at)?.toLocaleDateString() : '—', icon: 'Calendar' },
  ];

  return (
    <div className="bg-surface rounded-lg border border-border p-4">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Info" size={16} className="text-accent" />
        <h3 className="text-sm font-semibold text-text-primary">{t('drawingMetadata')}</h3>
      </div>
      <div className="space-y-3">
        {fields?.map(({ label, value, icon }) => (
          <div key={label} className="flex items-start gap-3">
            <div className="w-7 h-7 rounded-md bg-accent/10 flex items-center justify-center flex-shrink-0 mt-0.5">
              <Icon name={icon} size={13} className="text-accent" />
            </div>
            <div className="min-w-0">
              <p className="text-xs text-text-secondary">{label}</p>
              <p className="text-sm font-medium text-text-primary truncate">{value || '—'}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MetadataPanel;
